import { useMemo } from "react"

import { useSearchParamValues } from "../hooks/useSearchParamValues"

function parseUrlParamArray<T extends string = string>(
  value: string | null,
): T[] {
  if (!value) {
    return []
  }
  return value.split(",").filter(Boolean) as T[]
}

export interface DocumentFilterState {
  tags: string[]
  creator: string | null
  source: string | null
  assignedTo: string | null
  sourceKind: string | null
}

export interface UseFiltersResult {
  filterState: DocumentFilterState
  setFilterValue: (
    key: keyof DocumentFilterState,
    value: string | string[] | null,
  ) => void
  resetFilters: () => void
  activeFilterCount: number
}

export function useDocumentFilters(): UseFiltersResult {
  const { searchParams, setValue, reset } = useSearchParamValues<
    keyof DocumentFilterState
  >(/*useCommaSepArrays=*/ true)

  const filterState = useMemo<DocumentFilterState>(
    () => ({
      tags: parseUrlParamArray(searchParams.get("tags")),
      creator: searchParams.get("creator") || null,
      source: searchParams.get("source") || null,
      assignedTo: searchParams.get("assignedTo") || null,
      sourceKind: searchParams.get("sourceKind") || null,
    }),
    [searchParams],
  )

  const activeFilterCount = Object.values(filterState).filter((value) =>
    Array.isArray(value) ? value.length > 0 : value !== null,
  ).length

  return {
    filterState,
    resetFilters: reset,
    setFilterValue: setValue,
    activeFilterCount,
  }
}
